(() => {
  if (customElements.get('cls-light-preview')) return;
  const catalogs = new Map();
  function catalogFor(url) {
    if (!catalogs.has(url)) catalogs.set(url, fetch(url, {credentials:'omit'}).then(r => {if (!r.ok) throw new Error('Unavailable');return r.json();}).catch(e => {catalogs.delete(url);throw e;}));
    return catalogs.get(url);
  }
  class ClsLightPreview extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.buttons = [...this.querySelectorAll('[data-cls-state]')];
      this.frame = this.querySelector('[data-cls-frame]');
      this.status = this.querySelector('[data-cls-status]');
      this.addEventListener('click', e => {const button=e.target.closest('[data-cls-state]');if(button) this.select(button.dataset.clsState);}, {signal:this.controller.signal});
      catalogFor(this.dataset.catalog).then(async catalog => {
        const pair=catalog[this.dataset.productId];
        if (!pair?.on || !pair?.off || pair.on===pair.off || !this.isConnected) return;
        this.pair=pair;
        this.images={};
        this.hidden=false;
        const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();this.select('on');}}, {rootMargin:'400px'});
        this.observer=observer;observer.observe(this);
      }).catch(()=>{this.hidden=true;});
    }
    disconnectedCallback() {this.controller?.abort();this.controller=null;this.observer?.disconnect();}
    async select(state) {
      if(!this.pair || !['on','off'].includes(state))return;
      const request=this.request=(this.request||0)+1;
      this.setAttribute('aria-busy','true');this.status.textContent=this.dataset.loading;
      try {
        if(!this.images[state]) {
          const url=new URL(this.pair[state],document.baseURI);
          if(url.protocol!=='https:')throw new Error('Invalid URL');
          url.searchParams.set('width','1100');
          const img=new Image();img.decoding='async';img.alt=this.dataset.title+' — '+this.buttons.find(b=>b.dataset.clsState===state).textContent;img.src=url.href;
          await img.decode();this.images[state]=img;
        }
        if(!this.isConnected || request!==this.request)return;
        this.frame.replaceChildren(this.images[state]);this.frame.dataset.state=state;
        this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.clsState===state)));
        this.status.textContent=this.buttons.find(b=>b.dataset.clsState===state).textContent;
      } catch(e) {if(request===this.request)this.status.textContent=this.dataset.error;}
      finally {if(request===this.request)this.removeAttribute('aria-busy');}
    }
  }
  customElements.define('cls-light-preview',ClsLightPreview);
})();

